<template>
  <v-menu
    v-model="showPicker"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-on="on"
        append-icon="mdi-calendar"
        v-model="formattedDate"
        @click:clear="clear"
        v-bind="$attrs"
        @click:append="showPicker = true"
        @input="textChange"
      ></v-text-field>
    </template>
    <v-date-picker
      :disabled="readonly"
      v-model="dateValue"
      @change="change"
      @input="showPicker = false"
      :locale="userCultureCode"
      :first-day-of-week="1"
    ></v-date-picker>
  </v-menu>
</template>
<script>
import Utils from "@/ecm/common/Utils";

export default {
  props: {
    value: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.value) {
      this.dateValue = Utils.date.changeFormat(
        this.value,
        this.$store.getters["account/user"].MetricDateFormat,
        "YYYY-MM-DD"
      );
      this.formattedDate = this.value;
    }
  },
  data() {
    return {
      showPicker: false,
      userCultureCode: this.$store.getters["account/user"].CultureCode,
      formattedDate: "",
      dateValue: null,
    };
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modalKey];
    },
    userMask() {
      return this.$store.getters["account/user"].MetricDateFormat.replaceAll(
        "Y",
        "#"
      )
        .replaceAll("y", "#")
        .replaceAll("M", "#")
        .replaceAll("m", "#")
        .replaceAll("D", "#")
        .replaceAll("d", "#");
    },
  },
  methods: {
    clear() {
      this.dateValue = null;
      this.change();
    },
    change() {
      var value = null;
      if (this.dateValue) {
        value = Utils.date.changeFormat(
          this.dateValue,
          "YYYY-MM-DD",
          this.$store.getters["account/user"].MetricDateFormat
        );
      }
      this.formattedDate = value;
      this.$emit("input", value);
      this.$emit("change", value);
    },
    textChange() {
      var value = null;
      if (this.formattedDate) {
        value = Utils.date.changeFormat(
          this.formattedDate,
          this.$store.getters["account/user"].MetricDateFormat,
          "YYYY-MM-DD"
        );
      }
      this.dateValue = value;
      this.$emit("input", this.formattedDate);
      this.$emit("change", this.formattedDate);
    },
  },
};
</script>